/*
 * @Author: xieyu7 
 * @Date: 2019-05-08 10:43:11 
 * @Last Modified by: xieyu7
 * @Last Modified time: 2020-05-06 16:25:03
 */


 /* 请求类型 "基线：0-全部，1-正在停车，2-欠费补缴，3-已完成，4-未完成 */
 const requestTYPE = {
     ALL: 0,
     PARKING: 1,
     ARREARS: 2,
     DONE: 3,
     UNDONE: 4
 };
 /* 数据来源 0公众号/生活号,5出入口码,6场内码 */
 const sourceTYPE = {
    ONLINE: 0,
    ENTRYCODE: 5,
    PARKCODE: 6
};

/* url渠道 微信公众号 支付宝生活号 h5嵌入*/
const PAYCHANNEL = {
    APP: 2,
    ALI: 9,
    WX: 4
};
/* 渠道 */
const clientTYPE ={
    APP: 1,
    WX: 2,
    ALI: 3
};

//支付方式
const PAYTYPE = {
    ALI: 2,
    WX: 3,
    BLANCE: 6,
};
// 支付方式文字
const payTypeStr = {
    2:'支付宝',
    3:'微信',
    6:'余额'
}; 

// 支付方式图标
const payTypeImage ={
    2:'ic-alipay',
    3:'ic-wxpay',
    6:'ic-balance'
}; 

 export{
    requestTYPE,
    sourceTYPE,
    PAYCHANNEL,
    payTypeStr,
    payTypeImage,
    PAYTYPE,
    clientTYPE
 };